module.exports = __webpack_public_path__ + "img/6-min.ceca9a21.jpg";